export enum UserRole {
  CANDIDATE = 'CANDIDATE',
  COMPANY_REP = 'COMPANY_REP',
  MODERATOR = 'MODERATOR',
  ADMIN = 'ADMIN',
}

export enum ReputationTier {
  FLAGGED = 'FLAGGED',
  NEW = 'NEW',
  BRONZE = 'BRONZE',
  SILVER = 'SILVER',
  GOLD = 'GOLD',
}

export interface User {
  id: string;
  email: string;
  role: UserRole;
  companyId?: string;
  reputationScore: number;
  reputationTier: ReputationTier;
  emailVerifiedAt?: Date;
  createdAt: Date;
}

export interface AuthResponse {
  user: User;
  message: string;
}
